import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesNotificationSchemeAddRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-notification-scheme-add',
	path: '/secure/admin/AddNotificationScheme([!%]?[\\w]*).jspa',
};
